export const WABUNKA_EXPERIENCE_LIST_PER_PAGE = 18;

// 検索時、destinationの指定がない時に使うタグ
export const WABUNKA_ALL_AREA_TAG = 'all-area';
